(function () {
  function initWishlistMenu(swat) {
    if (!swat.ui || typeof swat.ui.open !== "function") return;

    const links = document.querySelectorAll("[data-pd-open-wishlist]");
    if (!links.length) return;

    links.forEach(function (link) {
      if (link.dataset.pdWishlistBound === "true") return;
      link.dataset.pdWishlistBound = "true";

      link.addEventListener("click", function (event) {
        event.preventDefault();

        const drawer = link.closest("header-drawer");
        const details = drawer
          ? drawer.querySelector("#Details-menu-drawer-container")
          : null;
        const menuToggle = details
          ? details.querySelector(":scope > summary")
          : null;

        if (details && details.open && menuToggle) {
          function openAfterMenuCloses() {
            if (details.open) return;

            details.removeEventListener("toggle", openAfterMenuCloses);
            swat.ui.open();
          }

          details.addEventListener("toggle", openAfterMenuCloses);
          menuToggle.click();
        } else {
          swat.ui.open();
        }
      });

      link.addEventListener("keydown", function (event) {
        if (event.key === " ") {
          event.preventDefault();
          link.click();
        }
      });
    });

    document.documentElement.classList.add("pd-wishlist-menu-ready");
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initWishlistMenu);
})();

(function () {
  const stickyCart = document.querySelector("sticky-add-to-cart");
  if (!stickyCart) return;

  const root = document.documentElement;
  const mobile = window.matchMedia("(max-width: 749px)");
  let previousHeight = -1;

  function updateChatPosition() {
    const height = mobile.matches
      ? Math.ceil(stickyCart.getBoundingClientRect().height)
      : 0;

    if (height === previousHeight) return;
    previousHeight = height;

    root.style.setProperty("--pd-sticky-cart-height", height + "px");
  }

  const observer = new ResizeObserver(updateChatPosition);
  observer.observe(stickyCart);

  window.addEventListener("resize", updateChatPosition, {
    passive: true
  });

  updateChatPosition();
})();

(function () {
  const root = document.documentElement;
  const mobile = window.matchMedia("(max-width: 749px)");
  let framePending = false;

  const overlaySelectors = [
    'dialog[open]',
    '[role="dialog"][aria-modal="true"]',
    '[role="dialog"][aria-label="Chat"]',
    '[role="dialog"][aria-label="Exclusive Member Offers Sign Up Form"]',
    '.fixed[class*="upnova-cart-drawer-width"]'
  ].join(",");

  function isVisible(element) {
    if (!element) return false;
    if (element.closest('[hidden], [aria-hidden="true"]')) return false;

    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      Number(style.opacity) > 0 &&
      rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < window.innerHeight &&
      rect.left < window.innerWidth
    );
  }

  function updateOverlayState() {
    framePending = false;

    const chatSelectors = [
    '.livesdk__chat-sdk-window__container[role="dialog"]',
    'iframe[src*="zoom.us/"][src*="/chat-client"]'
    ].join(",");

    const chatOpen =
    mobile.matches &&
    Array.from(document.querySelectorAll(chatSelectors)).some(isVisible);

    const menuOpen = Boolean(
      document.querySelector("#Details-menu-drawer-container[open]")
    );

    const filtersOpen = Boolean(
      document.querySelector(".ss__slideout--active")
    );

    const windowOpen = mobile.matches && Array.from(
      document.querySelectorAll(overlaySelectors)
    ).some(isVisible);

    root.classList.toggle("pd-mobile-chat-open", chatOpen);
    root.classList.toggle(
    "pd-mobile-overlay-open",
    mobile.matches && (menuOpen || filtersOpen || windowOpen || chatOpen)
    );
  }

  function scheduleUpdate() {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(updateOverlayState);
  }

  const observer = new MutationObserver(scheduleUpdate);

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["class", "style", "open", "hidden", "aria-hidden"]
  });

  window.addEventListener("resize", scheduleUpdate, { passive: true });
  document.addEventListener("toggle", scheduleUpdate, true);
  document.addEventListener("transitionend", scheduleUpdate, true);
  document.addEventListener("animationend", scheduleUpdate, true);

  updateOverlayState();
})();